import { Typography } from '@mui/material';
import React from 'react';
import Carousel from 'react-material-ui-carousel';

import scrlbar from "../utils/scrlbar.json"

import BodyPart from './BodyPart';



const HorizontalScrollBar = ({item,muscle}) => {
    // console.log(Alldta);
  return (
    <div>
       <center><Typography sx={{font:"", fontFamily:"   "}}>You were here million times in million different universe</Typography> </center> 
          <Carousel >
            {   scrlbar.map((item) => {
                return(<BodyPart item={item}  />)
            })
            }
          </Carousel>
      
    </div>
  )
}

export default HorizontalScrollBar
